import Swal from "sweetalert2";
import { updateUserData } from "../services/userService";

// ✅ Alerta básica
export const showBasicAlert = ({ title, text, icon }) => {
  Swal.fire({
    title,
    text,
    icon, // "info" | "success" | "error" | "warning" | "question"
    confirmButtonColor: "#3085d6",
  });
};

// ✅ Alerta de éxito
export const showSuccessAlert = ({ title, text }) => {
  Swal.fire({
    title,
    text,
    icon: "success",
    confirmButtonColor: "#198754",
  });
};

// ✅ Alerta de error
export const showErrorAlert = ({ title, text }) => {
  Swal.fire({
    title,
    text,
    icon: "error",
    confirmButtonColor: "#dc3545",
  });
};

// ✅ Confirmación con botones
export const showConfirmAlert = ({ title, text, confirmText, cancelText }) => {
  Swal.fire({
    title,
    text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: confirmText || "Sí",
    cancelButtonText: cancelText || "Cancelar",
  }).then((result) => {
    if (result.isConfirmed) {
      Swal.fire("Confirmado", "Acción aceptada.", "success");
    }
  });
};

// ✅ Input de texto
export const showInputAlert = ({ title, placeholder }) => {
  Swal.fire({
    title,
    input: "text",
    inputPlaceholder: placeholder || "Escribe aquí...",
    showCancelButton: true,
  }).then((result) => {
    if (result.value) {
      Swal.fire(`Ingresaste: ${result.value}`);
    }
  });
};

//Alert logout
export const showLogoutConfirm = async (logoutFn) => {
  Swal.fire({
    title: "¿Cerrar sesión?",
    text: "Tu sesión actual se cerrará",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Sí, cerrar sesión",
    cancelButtonText: "Cancelar",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        await logoutFn();
        window.location.href = "/login";
      } catch (error) {
        console.error("Error al cerrar sesión:", error);
        Swal.fire({
          title: "Error",
          text: "No se pudo cerrar sesión.",
          icon: "error",
          confirmButtonColor: "#dc3545",
        });
      }
    }
  });
};



// ✅ Temporizador
export const showTimerAlert = ({ title, text, ms }) => {
  let timerInterval;
  Swal.fire({
    title,
    html: `${text} <b></b>`,
    timer: ms || 3000,
    timerProgressBar: true,
    didOpen: () => {
      Swal.showLoading();
      const b = Swal.getHtmlContainer().querySelector("b");
      timerInterval = setInterval(() => {
        b.textContent = Swal.getTimerLeft();
      }, 100);
    },
    willClose: () => {
      clearInterval(timerInterval);
    },
  });
};

// ✅ Imagen personalizada
export const showImageAlert = ({ title, text, imageUrl }) => {
  Swal.fire({
    title,
    text,
    imageUrl,
    imageWidth: 300,
    imageHeight: 200,
    imageAlt: "Imagen personalizada",
  });
};


export const showProfileAlert = (user, uid) => {
  Swal.fire({
    title: "Mi perfil",
    html: `
      <div style="text-align:center" class="d-flex flex-row align-items-center justify-content-evenly">
        <img src="${user["06 Foto"]}" 
             alt="Foto perfil" 
             style="width:100px;height:100px;border-radius:50%;object-fit:cover;margin-bottom:10px;" />
        <button style="background-color:#ff6600;color:white;border:none;padding:5px 10px;border-radius:5px;margin-bottom:15px;height:45px;">
          CAMBIAR IMAGEN
        </button>
      </div>

      <div class="d-flex flex-row" style="text-align:left; font-size:14px; line-height:1;">
      <div>  
        <p><b>🔵Inscripción:</b> ${user["00 FechaRegistro"]}</p>
        <p><b>🔵Vigencia:</b> ${user["00 FechaVencimiento"]}</p>
        <p><b>🟢Escuela:</b> ${user["00 Escuela"]}</p>
        <p><b>🟢Nombre:</b> ${user["01 Nombre"]} ${user["02 Apellidos"]}</p>
        <p><b>🟢Curso:</b> ${user["00 Curso"]}</p>
        <p><b>🟢Grupo:</b> ${user["00 Grupo"]}</p>
      </div>
      <div>
        <p><b>📧Correo:</b> ${user["03 Email"]}</p>
        <p><b>🔑Contraseña:</b> ${user["04 Password"]}</p>
        <p><b>🟣Tiempo en la app:</b> ${user["22 IA"]} hr</p>
        <p><b>🟣Temas completados:</b> ${user["14 TemasT"]}</p>
        <p><b>🟣Estrellas obtenidas:</b> ${user["13 EstrellasT"]}</p>
        <p><b>📞Teléfono:</b> ${user["07 Telefono"]}</p>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: "Actualizar número",
    cancelButtonText: "Cerrar",
    confirmButtonColor: "#198754",
  }).then((result) => {
    if (result.isConfirmed) {
      Swal.fire({
        title: "Actualizar número",
        input: "text",
        inputLabel: "Nuevo número de teléfono",
        inputValue: user["07 Telefono"],
        showCancelButton: true,
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
      }).then(async (res) => {
        if (res.isConfirmed) {
          try {
            await updateUserData(uid, {
              "07 Telefono": res.value
            });
            Swal.fire("Número actualizado", "", "success");
          } catch (error) {
            console.error(error);
            Swal.fire("Error", "No se pudo actualizar el número", "error");
          }
        }
      });
    }
  });
};

export const showLoadingAlert = () => {
  Swal.fire({
    title: "Procesando...",
    text: "Por favor espera",
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

export const closeLoadingAlert = () => {
  Swal.close();
};